<template>
	<Modal :width="600" :title="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.single.title')"
		   :close-on-click-outside="false"
		   @close="closeNoticeModal">
		<template v-slot:body>
			<div class="modal-content">
				<div class="text_left">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.single.confirmation')"></span>
				</div>
				<table class="w_100 margin_top" style="border-collapse: collapse; border-spacing: 0">
					<tr>
						<td class="text_left"><span class="font_bold font_base">{{$t("common.invoiceAmount")}}:</span></td>
						<td class="text_right"><span>{{ invoiceAmountFormatted }}</span></td>
					</tr>
					<tr>
						<td colspan="2">
							<hr>
						</td>
					</tr>
					<template v-if="showWithRetention">
						<tr>
							<td class="text_left font_bold">
								{{ $t("seller.upload.price.withRetention.label", { retentionInPercent: retentionRateInPercentFormatted }) }}
							</td>
						</tr>
						<tr style="vertical-align: top">
							<td class="font_bold text_left valid_color">
								{{ $t("seller.upload.price.instantPayout") }}:
							</td>
							<td class="text_right">{{ instantPayoutInclRetentionFormatted }}</td>
						</tr>
						<tr style="vertical-align: top">
							<td class="font_bold text_left valid_color">{{ $t("seller.upload.price.withRetention.retentionPayout") }}:</td>
							<td class="text_right">{{ retentionPayoutFormatted }}</td>
						</tr>
					</template>
					<template v-else>
						<tr style="vertical-align: top">
							<td class="font_bold text_left valid_color">
								{{ $t("seller.upload.price.instantPayout") }}:
							</td>
							<td class="text_right">{{ instantPayoutInclRetentionFormatted }}</td>
						</tr>
					</template>
				</table>
				<div class="text_left margin_top">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.single.text')"></span>
				</div>
			</div>

			<div class="margin_r margin_top flex_end w_100">
				<md-button class="md-blank margin_r" @click="closeNoticeModal">{{$t("common.button.cancel")}}</md-button>
				<md-button @click="confirm" class="md-primary">{{ $t("common.continue") }}</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {formatAsMoneyAmount, formatAsPercentage} from "@/common/format";
import {enumDef} from "@/common/enumDefs";

export default {
	components: {
		Modal
	},
	props: {
		confirmationData: Object,
	},
	computed: {
		enumDef() {
			return enumDef;
		},
		invoiceAmountFormatted() {
			return formatAsMoneyAmount(this.confirmationData.invoiceAmount, { currency: this.confirmationData.currency });
		},
		retentionRateInPercentFormatted() {
			return formatAsPercentage(this.confirmationData.retentionCheck.retentionRate, { decimals: 0 });
		},
		instantPayoutInclRetentionFormatted() {
			return formatAsMoneyAmount(this.confirmationData.priceCheck.instantPayoutInclRetention, { currency: this.confirmationData.currency });
		},
		retentionPayoutFormatted() {
			return formatAsMoneyAmount(this.confirmationData.priceCheck.retentionPayout, { currency: this.confirmationData.currency });
		},
		showWithRetention() {
			return this.confirmationData.retentionCheck.sellWithRetention;
		}
	},
	methods: {
		closeNoticeModal() {
			this.$emit("close");
		},
		confirm() {
			this.$emit("confirm", this.confirmationData);
		},
	}
};
</script>